// class-schedule.utils.ts — 100% 순수 함수 (DI 불필요, 단위 테스트 용이)
export type Meridiem = "AM" | "PM";

export const isValidHour = (h: number) => h >= 0 && h <= 12;
export const isValidMinute = (m: number) => m >= 0 && m <= 59;
export const isInValidTime = (h: number, m: number) => h === 0 && m === 0;
export const isValidMeridiem = (f: string): f is Meridiem => f === "AM" || f === "PM";

/**
 * 12시간 기반을 24시간 기준으로 변환합니다.
 * @param hour 시간
 * @param meridiem 오전/오후
 * @returns 24시간 기준의 시간
 */
export const to24h = (hour: number, meridiem: Meridiem) => {
    if (meridiem === "PM" && hour !== 12) return hour + 12;
    if (meridiem === "AM" && hour === 12) return 0; // ← 기존 코드의 24는 잘못(12AM=00시)
    return hour;
};

/**
 * 시간을 문자열로 변환합니다.
 * @param h 시간
 * @param m 분
 * @param f 오전/오후
 * @returns 시간 문자열
 */
export const fmtTime = (h: string, m: string, f: string) => {
    const H = Number(h),
        M = Number(m);
    if (!isValidHour(H) || !isValidMinute(M) || !isValidMeridiem(f) || isInValidTime(H, M))
        return "";
    return `${String(H).padStart(2, "0")}:${String(M).padStart(2, "0")} ${f}`;
};

/**
 * 시간 차이를 계산합니다.
 * @param startMin 시작 시간
 * @param endMin 종료 시간
 * @returns 시간 차이
 */
export const diffHm = (startMin: number, endMin: number) => {
    const diff = endMin - startMin;
    return { diff, hours: Math.trunc(diff / 60), minutes: Math.abs(diff % 60) };
};

/**
 * 문자열 dayOfWeek 을 숫자로 변경해줍니다.
 */
export const convertDayOfWeekStringToNumber = (dayOfWeek: string) => {
    const dayOfWeekMap = {
        월요일: 1,
        화요일: 2,
        수요일: 3,
        목요일: 4,
        금요일: 5,
        토요일: 6,
        일요일: 0,
    };

    return dayOfWeekMap[dayOfWeek];
};
